import { forwardRef } from "react";
import { Landmark, Archive, TreePine, Lock } from "lucide-react";

const audiences = [
  {
    icon: Landmark,
    title: "Museus e Centros de Arte",
    description: "Gestão de acervo, exposições e empréstimos.",
  },
  {
    icon: Archive,
    title: "Arquivos Históricos e Bibliotecas",
    description: "Organização documental com hierarquias complexas.",
  },
  {
    icon: TreePine,
    title: "Ecomuseus e Núcleos Museológicos",
    description: "Gestão descentralizada de património material e imaterial.",
  },
  {
    icon: Lock,
    title: "Coleções Privadas e Fundações",
    description: "Inventário rigoroso com total privacidade.",
  },
];

const TargetAudience = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} id="para-quem" className="py-24 bg-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-muted-foreground font-semibold text-xs uppercase tracking-[0.2em] mb-3">Para Quem</p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Soluções à medida para:
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-border">
          {audiences.map((a) => (
            <div
              key={a.title}
              className="group text-center p-8 bg-background hover:bg-muted/50 transition-all duration-300"
            >
              <a.icon className="w-7 h-7 text-foreground mx-auto mb-5" strokeWidth={1.5} />
              <h3 className="text-lg font-bold text-foreground mb-2 font-serif">{a.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{a.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

TargetAudience.displayName = "TargetAudience";

export default TargetAudience;
